export default __webpack_public_path__ + "static/media/text2.46ecfd60.glb";